export default function getPercentCompleted(goal) {
  // Don't use round here, so that we show 99% instead of 100% when near-but-not-complete.
  return Math.floor((goal.completed / goal.total) * 100);
}
